export enum QueryKey {
  whoami = 'whoami',
  fetchUser = 'fetchUser',
  users = 'users',
  supportTextGenerationStatus = 'supportTextGenerationStatus',
  getDialogueSnapshot = 'getDialogueSnapshot',
  getAiDebug = 'getAiDebug',
  getFixedPromptTextGeneration = 'getFixedPromptTextGeneration',
  assistantTextGeneration = 'assistantTextGeneration',
  assistantDialoguesList = 'assistantDialoguesList',
  messagesFeedback = 'messagesFeedback',
}
